// extracted by mini-css-extract-plugin
export default {"wrapper":"Helmet_wrapper__xi20P"};